import React from 'react';
import { TemplateGalleryCard } from '@common/types';
import { TFunction } from '@wix/fe-essentials-standalone/i18n';
import s from '../TemplateCard.module.scss';

const TemplateCardLinkWrapper = ({
  template,
  children,
  templateHref,
  onClick,
  setHover,
  setFocused,
  t,
  actionButton,
  actionButtonVisibility = 'always',
}: {
  t: TFunction;
  templateHref: string;
  onClick: () => void;
  template: TemplateGalleryCard;
  children: React.ReactNode;
  setHover: React.Dispatch<React.SetStateAction<boolean>>;
  setFocused: React.Dispatch<React.SetStateAction<boolean>>;
  actionButton?: React.ReactNode;
  actionButtonVisibility?: 'hover' | 'always';
}) => {
  return (
    <div
      aria-labelledby={`template-title-${template.title}`}
      className={s.cardWrapper}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => {
        setHover(false);
        template.media?.animatedPreview && setFocused(false);
      }}
    >
      <a
        data-hook={`template-card-container-${template.id}`}
        href={templateHref}
        aria-label={t('marketplace.templates-page.view-template-cta')}
        className={s.cardContainer}
        onClick={onClick}
      >
        {children}
      </a>
      {actionButton && (
        <div
          className={`${s.templateCardActionButton} ${
            actionButtonVisibility === 'hover'
              ? s.templateCardActionButtonHover
              : ''
          }`}
        >
          {actionButton}
        </div>
      )}
    </div>
  );
};

export default TemplateCardLinkWrapper;
